<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-container class="pa-5">
        <h2 class="font-weight-regular">Pindah Sekolah Anggota ke Kelompok Pendampingan Lainnya</h2>
        <p class="body-2 grey--text text--darken-1">
          Silahkan Pilih Sekolah Anggota yang ingin dipindahkan dan Pilih Kelompok Pendampingan tujuannya.
        </p>
        <v-divider />
        <v-alert v-if="message" dense text type="error" class="mt-5">
          {{ message }}
        </v-alert>
        <div class="mt-5">
          <h4 class="font-weight-regular">Sekolah yang akan dipindahkan</h4>
          <div v-if="!kandidat || (kandidat && !$isObject(kandidat))">
            <v-btn class="primary" depressed @click="onPilihSekolah">
              <v-icon left>mdi-home</v-icon>
              Pilih Sekolah
            </v-btn>
          </div>
          <v-list-item v-if="kandidat && $isObject(kandidat)" class="px-0 mb-3">
            <v-list-item-content class="py-0">
              <v-row no-gutters>
                <v-col cols="9" md="3" sm="9">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue">
                      <v-icon dark>mdi-home</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(kandidat, 'sekolah.data.nama') || $getDeepObj(kandidat, 'sekolah.nama') || '-' }}
                      </div>
                      <div class="black--text body-2">
                        <b>NPSN</b> {{ $getDeepObj(kandidat, 'sekolah.data.npsn') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="9" md="3" sm="9">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <label><small>Alamat Sekolah </small></label>
                      </v-list-item-title>
                      <div class="link black--text body-2">
                        {{
                          $getDeepObj(kandidat, 'sekolah.data.alamat') || $getDeepObj(kandidat, 'sekolah.alamat') || '-'
                        }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="9" md="3" sm="9">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <label><small>Nama Kelompok Pendampingan</small></label>
                      </v-list-item-title>
                      <div class="link black--text body-2">
                        {{ $getDeepObj(initValue, 'nama') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="3" class="my-auto">
                  <v-btn icon color="red" @click="onHapusSekolah"><v-icon>mdi-close-circle</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div class="mt-5">
          <h4 class="font-weight-regular">Kelompok Pendampingan Tujuan</h4>
          <div v-if="!tujuan || (tujuan && !$isObject(tujuan))">
            <v-btn class="primary" depressed @click="onPilihKelompok">
              <v-icon left>mdi-hospital-building</v-icon>
              Pilih Kelompok
            </v-btn>
          </div>
          <v-list-item v-if="tujuan && $isObject(tujuan)" class="px-0 mb-3">
            <v-list-item-content class="py-0">
              <v-row no-gutters>
                <v-col cols="9">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue">
                      <v-icon dark>mdi-hospital-building</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(tujuan, 'nama') || '-' }}
                      </div>
                      <div class="black--text body-2">
                        <span class="info--text">
                          {{ ($getDeepObj(tujuan, 'psp_kp_pa_sekolahs.data') || []).length }}
                        </span>
                        Sekolah Anggota
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="3" class="my-auto">
                  <v-btn icon color="red" @click="onHapusKelompok"><v-icon>mdi-close-circle</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-container>
    </v-card>
    <kandidat ref="kandidat" title="Pilih Sekolah" :sekolahs="sekolahs" />
    <tujuan
      ref="tujuan"
      title="Pilih Kelompok Pendampingan"
      :kp-pa-id="(initValue && initValue.psp_kp_pa_id) || null"
      :gelombang="gelombang"
    />
  </div>
</template>
<script>
import Kandidat from './Kandidat';
import Tujuan from './Tujuan';
export default {
  components: { Kandidat, Tujuan },
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    gelombang: {
      type: [Number, String],
      default: 2,
    },
  },
  computed: {
    sekolahs() {
      return this.$getDeepObj(this.initValue, 'psp_kp_pa_sekolahs.data') || [];
    },
  },
  data() {
    return {
      form: {},
      kandidat: null,
      tujuan: null,
      message: null,
    };
  },
  methods: {
    reset() {
      this.$set(this, 'kandidat', null);
      this.$set(this, 'tujuan', null);
    },

    getValue() {
      return {
        kp_pa_sekolah_id: this.$getDeepObj(this.kandidat, 'psp_kp_pa_sekolah_id') || '',
        kp_pa_id_tujuan: this.$getDeepObj(this.tujuan, 'id') || '',
      };
    },

    validate() {
      const value = this.getValue() || {};
      this.message = !value.kp_pa_sekolah_id
        ? 'Data Sekolah yang ingin dipindah belum dipilih'
        : !value.kp_pa_id_tujuan
        ? 'Data Kelompok tujuan belum dipilih'
        : '';

      return !this.message;
    },

    onPilihSekolah() {
      this.$refs.kandidat.open().then((data) => {
        this.message = null;
        this.kandidat = data;
      });
    },

    onHapusSekolah() {
      this.$set(this, 'kandidat', null);
    },

    onPilihKelompok() {
      this.$refs.tujuan.open().then((data) => {
        this.message = null;
        this.tujuan = data;
      });
    },

    onHapusKelompok() {
      this.$set(this, 'kandidat', null);
    },
  },
};
</script>
